import { useI18n } from '@/hooks/useI18n';
import { useDocumentLang } from '@/hooks/useDocumentLang';

export const TermsPage = () => {
  const { t } = useI18n();
  useDocumentLang();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">
            {t('terms.title')}
          </h1>

          <div className="prose prose-gray max-w-none">
            <p className="text-gray-600 mb-6">
              {t('terms.lastUpdated')}: {new Date().toLocaleDateString()}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('terms.intro.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('terms.intro.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('terms.serviceDescription.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('terms.serviceDescription.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('terms.userResponsibilities.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('terms.userResponsibilities.intro')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>{t('terms.userResponsibilities.item1')}</li>
                <li>{t('terms.userResponsibilities.item2')}</li>
                <li>{t('terms.userResponsibilities.item3')}</li>
                <li>{t('terms.userResponsibilities.item4')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('terms.intellectualProperty.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('terms.intellectualProperty.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('terms.limitation.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('terms.limitation.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('terms.termination.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('terms.termination.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('terms.changes.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('terms.changes.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('terms.contact.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('terms.contact.content')}
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
